import { render, staticRenderFns } from "./0008.vue?vue&type=template&id=05cdf210&scoped=true&"
import script from "./0008.vue?vue&type=script&lang=js&"
export * from "./0008.vue?vue&type=script&lang=js&"
import style0 from "./0008.vue?vue&type=style&index=0&id=05cdf210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdf210",
  null
  
)

export default component.exports